<template lang="html">
  <!-- start: loader -->
  <div class="loaderParent">
  <div class="loader">
    <div class="spinner"></div>
  </div>
</div>
  <!-- end: loader -->
</template>

<script>
export default {
  name: 'loader'
}
</script>

<style scoped>
@media screen and (min-width: 34em) {
  .loader {
    /* left: 25% !important; */
  }
}
.loaderParent {
  height: 100%;
  width: 100%;
  z-index: 99 !important;
  position: fixed;
  top: 0px;
  left: 0px;
  opacity: 0.4;
  background: black;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999 !important;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: black;
  opacity: 0.4;
}

.spinner {
  height: 15vh;
  width: 15vh;
  border: 6px solid rgba(0, 174, 239, 0.2);
  border-top-color: rgba(0, 174, 239, 0.8);
  border-radius: 100%;
  animation: rotation 0.6s infinite linear 0.25s;
  opacity: 0;
}

@keyframes rotation {
  from {
    opacity: 1;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(359deg);
  }
}
</style>
